module.exports = __webpack_public_path__ + "@/assets/img/Онбордингgevfacwd.8624f32d.png";